module.exports = __webpack_public_path__ + "media/images/athletes/1666-79d9fcf9aa0419943cfc0611434cd966.png";